// extracted by mini-css-extract-plugin
module.exports = {"hoverEffect":"serverSentEventsHandler_hoverEffect__3XENO"};